module.exports = __webpack_public_path__ + "static/media/building.2b6c5789.svg";